import PropTypes from 'prop-types';
import React from 'react';
import { useInView } from 'react-intersection-observer';
import SocialIcons from '../global/social-icons';

function ContactSidebar(props) {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.25
  });

  return (
    <div className={`contact__sidebar ${inView ? 'in-view' : ''}`} ref={ref}>
      <div className="contact__sidebar-item enquiries">
        <p>Enquiries</p>

        <a href="mailto:hello@headnorth.agency" className="contact__email">
          <h3>hello@headnorth.agency</h3>
        </a>
      </div>
      <div className="contact__sidebar-item social">
        <p>Social Media</p>

        <SocialIcons />
      </div>
    </div>
  );
}

ContactSidebar.propTypes = {
  email: PropTypes.string,
  address: PropTypes.string,
  phone: PropTypes.string,
  map: PropTypes.string
};

export default ContactSidebar;
